import React from 'react';
import { Col, Row, Card } from 'antd';
import WifiIndicator, { DBMToSignalStrength } from 'react-wifi-indicator';
import { withTranslation } from 'react-i18next';

class WifiInformationCard extends React.Component {
  constructor(props) {
    super(props);
  }
  wifiSignalQuality = (wifiSignalRange, t) => {
    if (wifiSignalRange > -30) {
      return t('label_excellent');
    } else if (wifiSignalRange > -50) {
      return t('label_veryGood');
    } else if (wifiSignalRange > -60) {
      return t('label_good');
    } else if (wifiSignalRange > -67) {
      return t('label_average');
    } else if (wifiSignalRange > -70) {
      return t('label_poor');
    } else if (wifiSignalRange < -70) {
      return t('label_veryPoor');
    }
    return t('label_notConnected');
  };

  render() {
    const { t } = this.props;
    return (
      <Card
        title={<span style={{ marginLeft: '45%' }}>{t('title_wifi')}</span>}
        bordered={true}
      >
        <Row style={{ marginLeft: '50px' }}>
          <Col span={8}>
            <Card style={{ width: 200, height: 200, textAlign: 'center' }}>
              <h3>{t('label_signalStrength')}</h3>
              <br />
              <WifiIndicator
                strength={DBMToSignalStrength(
                  parseInt(this.props.signalStrength, 10),
                )}
                style={{
                  height: '46px',
                  marginTop: '-5px',
                }}
              />
              <br />
              <h4
                style={{
                  fontSize: '13px',
                  marginTop: '20px',
                  fontWeight: 'bold',
                }}
              >
                {this.wifiSignalQuality(
                  parseInt(this.props.signalStrength, 10),
                  t,
                )}
              </h4>
            </Card>
          </Col>
          <Col span={8}>
            <Card style={{ width: 200, height: 200, textAlign: 'center' }}>
              <h3>{t('label_dailyWifiData')}</h3>
              <br />
              <br />
              <h4 style={{ fontSize: 18 }}>
                {(parseFloat(this.props.dailyWifiData) / 1000000000).toFixed(2)}{' '}
                GB
              </h4>
            </Card>
          </Col>
          <Col span={8}>
            <Card style={{ width: 200, height: 200, textAlign: 'center' }}>
              <h3>{t('label_hourlyWifiData')}</h3>
              <br />
              <br />
              <h4 style={{ fontSize: 18 }}>
                {(parseFloat(this.props.hourlyWifiData) / 1000000000).toFixed(
                  2,
                )}{' '}
                GB
              </h4>
            </Card>
          </Col>
        </Row>
      </Card>
    );
  }
}

export default withTranslation()(WifiInformationCard);
